import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import FreeSpin from './FreeSpin';
import './FreeSpin.css';

export default function FreeSpinPage({ userData, transactions }) {
  const API_BASE_URL = useMemo(() => (process.env.REACT_APP_API_URL || 'https://api2b.pro'), []);
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  const logoUrl = null;
  const navigate = useNavigate();

  return (
    <div>
      <button className="fs-page-close" onClick={() => navigate('/')}>Close</button>
      <FreeSpin
        apiBaseUrl={API_BASE_URL}
        token={token}
        logoUrl={logoUrl}
        userData={userData}
        transactions={transactions}
        onResult={(amount) => console.log('Spin recorded:', amount)}
      />
    </div>
  );
}
